// Generated by tools/gen-backend-hooks.ts — do not edit by hand.
// One hook per endpoint in backend/bagsPage/.

import { makeBackendHook } from './_client'

export type { BackendQuery, TriggerOptions } from './_client'

/** POST /api/rpc/bagsPage/addBagEntry */
export const useAddBagEntry = makeBackendHook('bagsPage', 'addBagEntry')

/** POST /api/rpc/bagsPage/deleteBagEntry */
export const useDeleteBagEntry = makeBackendHook('bagsPage', 'deleteBagEntry')

/** POST /api/rpc/bagsPage/getBagDimensions */
export const useGetBagDimensions = makeBackendHook('bagsPage', 'getBagDimensions')

/** POST /api/rpc/bagsPage/getBagStatus */
export const useGetBagStatus = makeBackendHook('bagsPage', 'getBagStatus')

/** POST /api/rpc/bagsPage/updateBagDimensions */
export const useUpdateBagDimensions = makeBackendHook('bagsPage', 'updateBagDimensions')

/** POST /api/rpc/bagsPage/updateBagSettings */
export const useUpdateBagSettings = makeBackendHook('bagsPage', 'updateBagSettings')
